import {sendPushNotification} from "../http/requests/profile";

export default {
  data () {
    return {
      pushNotification: {
        subscription: null
      }
    }
  },
  methods: {
    async initPush() {
      if (Notification.permission  !== "granted") {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return false;
      }

      const registration = await navigator.serviceWorker.ready;

      this.pushNotification.subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(process.env.VUE_APP_VAPID_PUBLIC_KEY),
      });

      await sendPushNotification(this.pushNotification.subscription)
    },

    urlBase64ToUint8Array(base64String) {
      const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding)
        .replace(/-/g, "+")
        .replace(/_/g, "/");

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    }
  }
}
